import React, { createContext, useContext, useEffect, useState } from 'react';
import { LoadingStatus } from '@paycor/pacl';
import { loadTranslations } from 'utils/i18n-util';

const LANGUAGE_MODULES = ['application'];

const TranslationContext = createContext();
TranslationContext.displayName = 'TranslationContext';

export const TranslationProvider = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [lang, setLang] = useState(getLanguage());

	useEffect(() => {
		fetchTranslation();
	}, [lang]);

	const fetchTranslation = async () => {
		try {
			await loadTranslations(lang, LANGUAGE_MODULES);
			setLoading(false);
		} catch (error) {
			console.error('Error loading translations:', error);
			setLoading(false);
		}
	};

	const changeLanguage = async (newLang) => {
		setLoading(true);
		setLang(newLang);
		await fetchTranslation();
	};

	return (
		<TranslationContext.Provider value={{ lang, changeLanguage }}>
			{loading ? <LoadingStatus /> : children}
		</TranslationContext.Provider>
	);
};

export const useTranslation = () => useContext(TranslationContext);

function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2)
		return parts
			.pop()
			.split(';')
			.shift();
}

function getLanguage() {
	return getCookie('paycorCulture') || 'en';
}
